import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
  },
  side: {
    background: theme.palette.blue.lightest,
    padding: '2% 0',
  },
  main: {},
}));

function RegisterLayout({ children, SideComponent }) {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container>
      <Grid className={classes.side} container item xs={3}>
        {SideComponent}
      </Grid>

      <Grid className={classes.main} container item xs={9}>
        {children}
      </Grid>
    </Grid>
  )
}

export default RegisterLayout;
